module.exports = __webpack_public_path__ + "img/count_stock.e452f074.png";